import {Component, HostListener, OnInit, ChangeDetectorRef} from '@angular/core';
import {ChatService} from '../chat.service';
import {BlockModel} from '../../model/block.model';
import {ActivatedRoute, Router} from '@angular/router';
import {first} from "rxjs/operators";
import {QuizService} from '../../service/quiz.service';
import {environment} from "../../../environments/environment";
import {InstallService} from "../../service/install.service";
import {DASHBOARD_STEPS} from "../../config/project";
import {UserReturningService} from "../../service/userReturning.service";
import {CHAT_KIND} from "./dashboard.config";
import {UserAnswerMode, UserAnswerStateMode} from '../../model/user-answer.mode';
import { isNull } from 'util';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
    blocks: BlockModel[];

    applicationDesc = '';
    appealDesc = '';
    appInstalled = false;
    isBrowser;
    IOSInstallBtn = false;
    ios_popup_text;
    androidInstallBtn = false;
    deferredPrompt: any;

    firstStep = true;
    secondStep = false;
    thirdStep = false;
    fourthStep = false;
    fifthStep = false;
    sixthStep = false;
    seventhStep = false;
    eighthStep = false;
    ninthStep = false;
    tenthStep = false;
    eleventhStep = false;
    twelfthStep = false;
    thirteenthStep = false;
    fourteenthStep = false;
    fifteenthStep = false;
    showAljBack = true;
    question = {};

    selectEarningOver1KQuestion = {
        "answer": "",
        "questionId": 97,
        "title": "Please Provide us a detailed synopsis of your current work. What do you do? How many days a week? What is your Gross Pay? Why Can’t you work more hours? We will review and contact you."
    };

    otherIssue = {
        "answer": "",
        "questionId": 96,
        "title": "Please Provide us a detailed synopsis of your situation, and how we can help. We will review it and let you know if it’s something we think we can effectively accomplish."
    };

    appealStartQuestion ={
        "answerChoiceTitle": "IV",
        "answerElement": "",
        "answerLength": 2,
        "choices": [
          {"label": "Supplemental Security Income", "value": 0, "selected": 0},
          {"label": "Retirement Survivors Disability", "value": 0, "selected": 0},
          {"label": "I received BOTH", "value": 0, "selected": 0},
          {"label": "My SSA Portal indicated a denial", "value": 0, "selected": 0},
        ],
        "fieldTitle": "",
        "fieldType": "SELECT",
        "questionId": 0,
        "questionTitle": "title"
      }
      popupMessage = {
        show: false,
        message: 'text',
        success: true
    }

    infoText = DASHBOARD_STEPS[0].text;
    CHAT_KIND = CHAT_KIND;

    @HostListener('window:beforeinstallprompt', ['$event'])
    onbeforeinstallprompt(e) {
        e.preventDefault();

        console.log('before', e);

        // store install avaliable event
        this.deferredPrompt = e;

        // show button with display:block;
        this.androidInstallBtn = true;
        //this.appInstalled = true;
        //this.appInstalled = false;
    }

    constructor(
        private chatService: ChatService,
        private quizService: QuizService,
        private installService: InstallService,
        private userReturningService: UserReturningService,
        private route: ActivatedRoute,
        private router: Router,
        private cdr: ChangeDetectorRef) {
        // if(environment.production){
            this.installService.visible.subscribe((value: any) => this.installChanged(value));
        // }
    }

    ngOnInit() {
        this.chatService.setLastScreen(false, false);
        this.updateViewPortUnits();
        window.onresize = this.updateViewPortUnits;

        if (this.isIos()) {
            this.appInstalled = false;
        }

        window.addEventListener('appinstalled', (evt) => {
            this.appInstalled = true;
        });

        let $this = this;
        setTimeout(function(){
            if (!$this.isIos() && !$this.androidInstallBtn) {
                $this.appInstalled = true;
            }
        },3000);

        this.route.queryParams.subscribe(val => {
          if (val && val.isBack==='appeal') {
            this.goToStep(9);
          }
          else if (val && val.isBack==='application'){
            this.goToStep(6);
          }
          else if (val && val.type=='application'){
            this.goToStep(13);
          } 
          else if (val && val.type=='appeal'){
            this.goToStep(14);
          }
          
        });

        this.route.queryParams.subscribe(val => {
            if (val && val.isOther==='yes'){
                this.question = val.question;
                console.log(this.question);
                
                this.goToStep(12);
            }
        });
    }

    updateViewPortUnits() {
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }

    handleQuizStart(kind?) {
        if (kind) {
            this.setKindOfChat(kind);
        }
        this.router.navigate(['/login']);
    }

    installApp() {
        console.log('install');
    }

    inIframe() {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    }

    goToStep(number, kind?) {
        if (kind) {
            this.setKindOfChat(kind);
        }
        this.resetStep();
        switch (number) {
            case 1: {
                this.firstStep = true;
                this.infoText = DASHBOARD_STEPS[0].text;
                this.router.navigate(['/dashboard']);
                break;
            }
            case 2: {
                this.secondStep = true;
                this.infoText = DASHBOARD_STEPS[1].text;
                break;
            }
            case 3: {
                this.thirdStep = true;
                this.infoText = DASHBOARD_STEPS[2].text;
                break;
            }
            case 4: {
                // this.userReturningService.setUserIsNotReturning();
                this.fourthStep = true;
                this.infoText = DASHBOARD_STEPS[3].text;
                break;
            }
            case 5: {
                this.fifthStep = true;
                this.infoText = DASHBOARD_STEPS[4].text;
                break;
            }
            case 6: {
                this.userReturningService.setUserIsNotReturning();
                this.sixthStep = true;
                this.infoText = DASHBOARD_STEPS[5].text;
                break;
            }
            case 7: {
                this.seventhStep = true;
                this.infoText = DASHBOARD_STEPS[7].text;
                break;
            }
            // case 7: {
            //     this.seventhStep = true;
            //     this.infoText = DASHBOARD_STEPS[6].text;
            //     break;
            // }
            case 8: {
                this.eighthStep = true;
                this.infoText = '';
                break;
            }
            case 9:{
                this.ninthStep = true;
                this.infoText = DASHBOARD_STEPS[9].text;
                break;
            }
            case 10:{
                this.tenthStep = true;
                this.infoText = DASHBOARD_STEPS[1].text;
                break;
            }
            case 11:{
                this.eleventhStep = true;
                this.infoText = DASHBOARD_STEPS[3].text;
                break;
            }
            case 12:{
                this.twelfthStep = true;
                this.infoText = '';
                // this.infoText = DASHBOARD_STEPS[9].text;
                break;
            }
            case 13:{
                this.thirteenthStep = true;
                this.infoText = this.selectEarningOver1KQuestion.title;
                this.getAnswer(97);
                break;
            }
            case 14:{
                this.fourteenthStep = true;
                this.infoText = this.otherIssue.title;
                this.getAnswer(96);
                break;
            }
            case 15:{
                this.fifteenthStep = true;
                break;
            }
        }
    }

    resetStep() {
        this.firstStep = false;
        this.secondStep = false;
        this.thirdStep = false;
        this.fourthStep = false;
        this.fifthStep = false;
        this.sixthStep = false;
        this.seventhStep = false;
        this.eighthStep = false;
        this.ninthStep = false;
        this.tenthStep = false;
        this.eleventhStep = false;
        this.twelfthStep = false;
        this.thirteenthStep = false;
        this.fourteenthStep = false;
        this.fifteenthStep = false;
    }

    setKindOfChat(kind) {
        this.chatService.setChatKind(kind);
    }

    installChanged(value) {
        this.isBrowser = value;
    }

    appInstalledChanged(value) {
        this.appInstalled = value;
    }

    install() {


        if (this.isIos() && !this.isInStandaloneMode()) {
            let userAgent = window.navigator.userAgent.toLowerCase();
            this.IOSInstallBtn = true;
            document.body.style.overflow = 'hidden';

            let device = 'device';

            if  (/iphone/.test( userAgent )) {
                device = 'IPhone';
            } else if (/ipad/.test( userAgent )) {
                device = 'IPad';
            }
            this.ios_popup_text = `Install this webapp on your ${device}: `;
        } else {
            this.deferredPrompt.prompt();
            this.deferredPrompt.userChoice.then(choiceResult => {
                if (choiceResult.outcome === 'accepted') {
                    // user accept the prompt
                    // lets hidden button
                    //this.androidInstallBtn = false;
                    //this.appInstalled = true;
                    //document.location.reload();

                    this.appInstalled = true;

                } else {
                    console.log('User dismissed the prompt');
                }
                //this.deferredPrompt = null;
            });
        }
    }

    // Detects if device is in standalone mode
    isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator['standalone']);
    isIos(){
        let userAgent = window.navigator.userAgent.toLowerCase();
        return /iphone|ipad|ipod/.test( userAgent );
    }

    isMobile(){
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
            return true
        }
        else{
            return false
        }
    }

    useBrowser() {
        localStorage.useBrowser = true;
        //this.installService.hide();
    }

    closeIOSInstallPopup() {
        this.IOSInstallBtn = false;
        document.body.style.overflow = 'auto';
    }

    isRunningStandalone() {
        return (window.matchMedia('(display-mode: standalone)').matches);
    }

    isUserReturning() {
        this.userReturningService.setUserReturning();
        this.setKindOfChat(CHAT_KIND.application);
        this.handleQuizStart();
    }
    goBack() {
        window.history.back();
    }

    showErrorPopup(message) {
        this.popupMessage.show = true;
        this.popupMessage.success = false;
        this.popupMessage.message = message;
    }
    showSuccessPopup(message) {
        this.popupMessage.show = true;
        this.popupMessage.success = true;
        this.popupMessage.message = message;
    }

    saveAnswer(type){
        var answer = null;
        if(type=='application'){
            answer = {
                questionId: this.selectEarningOver1KQuestion.questionId,
                title: this.selectEarningOver1KQuestion.answer
            };
        }else if(type=='appeal'){
            answer = {
                questionId: this.otherIssue.questionId,
                title: this.otherIssue.answer
            };
        }
        this.chatService.setAnswer(answer).subscribe(rez => {
            if (rez['status']) {
                console.log('success');
                this.showSuccessPopup('Your answer has been saved');
                
            }else{  
                this.showErrorPopup('Something went wrong!');
            }
        });
    }

    closePopup(){
        this.goToStep(1);
        console.log('closed');
        
    }

    getAnswer(questionId){
        this.chatService.getAnswer({'questionId':questionId}).subscribe(rez => {
            if (rez['status']) {
                console.log('success');
                if(!isNull(rez['result']) && questionId == 96)
                    this.otherIssue.answer = rez['result'].title;

                if(!isNull(rez['result']) && questionId == 97)
                    this.selectEarningOver1KQuestion.answer = rez['result'].title;
            }
        });    
    }

    hideAlj(params:any){
        this.showAljBack = params;
    }

}
